import { render, staticRenderFns } from "./admin-followup.vue?vue&type=template&id=46d2ab15"
import script from "./admin-followup.vue?vue&type=script&lang=js"
export * from "./admin-followup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports